var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRwanda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 23.4648 0.881485 26.7238 2.4318 29.5652L20 31.3044L37.5682 29.5652C39.1185 26.7238 40 23.4648 40 20L20 18.2609L0 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5683 10.4348C34.1762 4.21795 27.5809 6.10352e-05 20.0001 6.10352e-05C12.4192 6.10352e-05 5.82397 4.21795 2.43186 10.4348C0.881545 13.2763 6.10352e-05 16.5352 6.10352e-05 20.0001H40.0001C40.0001 16.5352 39.1186 13.2763 37.5683 10.4348Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 40C27.5808 40 34.176 35.7821 37.5681 29.5652H2.4317C5.82381 35.7821 12.419 40 19.9999 40Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6088 11.7048L25.0514 12.8538L23.7507 15.2194L26.4031 14.712L26.7392 17.3913L28.5865 15.4207L30.434 17.3913L30.77 14.712L33.4224 15.2192L32.1217 12.8537L34.5642 11.7048L32.1217 10.5559L33.4224 8.19032L30.7701 8.69767L30.4339 6.01837L28.5865 7.989L26.7391 6.01837L26.4031 8.69767L23.7506 8.19032L25.0513 10.556L22.6088 11.7048Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwanda);
export default __webpack_public_path__ + "static/media/rwanda.c2a5ee3c6f26c8c6e10039cedc14e956.svg";
export { ForwardRef as ReactComponent };